export const TIMER_DURATION = 15
export const QUESTION_COUNT = 10
export const RIGHT_REVEAL_DELAY = 1500
export const WRONG_REVEAL_DELAY = 2000